import React from 'react';

type PropTypes = {
  condition: boolean;
  wrapper: (children: React.ReactNode) => React.ReactNode;
};

export const ConditionalWrapper: React.FC<PropTypes> = ({ condition, wrapper, children }) =>
  condition ? <>{wrapper(children)}</> : <>{children}</>;
